import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app-routing.module';
import {TokenService} from './shared/services/token.service';
import {UserService} from './shared/services/user.service';
import {RestService} from './shared/services/rest.service';
import {HttpCallsInterceptor} from './shared/services/http-calls.interceptor';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {MAT_AUTOCOMPLETE_DEFAULT_OPTIONS} from '@angular/material/autocomplete';
import {MAT_SELECT_CONFIG, MatSelectModule} from '@angular/material/select';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule} from '@angular/material/snack-bar';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {GeneralConstant} from './shared/constants/GeneralConstant';
import {ResponseSnackbarService} from './shared/services/response-snackbar.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LogoutComponent} from './shared/components/logout/logout.component';
import {LayoutModule} from './modules/layout/layout.module';
import {PermissionService} from './shared/services/permission.service';
import {RedirectComponent} from './shared/components/redirect.component';
import {NoPermissionComponent} from './shared/components/no-permission/no-permission.component';
import {TaxService} from './shared/services/tax.service';
import {NgxStripeModule, StripeService} from 'ngx-stripe';
import {environment} from '../environments/environment';
import {PaymentModalModule} from './modules/financial/payment/payment-modal/payment-modal.module';
import {
  PaymentSuccessModalModule
} from './modules/financial/payment/payment-success-modal/payment-success-modal.module';
import {DatePipe} from '@angular/common';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MatMomentDateModule,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {PaymentCheckoutComponent} from './modules/financial/payment-checkout/payment-checkout.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PermissionModule} from './shared/permission';
import {ConfirmModalModule} from './modules/shared/modules/confirm-modal/confirm-modal.module';
import {PublicInvoiceViewComponent} from './modules/financial/public-invoice-view/public-invoice-view.component';
import {RounderModule} from './shared/utils/pipes';
import {SpinnerButtonModule} from './modules/shared/modules/spinner-button/spinner-button.module';
import {PermissionPathComponent} from './modules/permission-path/permission-path.component';
import {
  QuickbooksAuthenticationComponent
} from './modules/financial/quickbooks-authentiation/quickbooks-authentication.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {PortalSelectModule} from './modules/shared/modules/portal-select/portal-select.module';
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
// Import all Froala Editor plugins.
import 'froala-editor/js/plugins.pkgd.min.js';

// Import a single Froala Editor plugin.
import 'froala-editor/js/plugins/align.min.js';

// Import a Froala Editor language file.
import 'froala-editor/js/languages/de.js';

// Import a third-party plugin.
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/embedly.min';
import {ButtonModule, DirectiveModule} from '@ucx/ui-cmp';
import {SequenceService} from './shared/services/sequence.service';
import {OwnerService} from './shared/services/owner.service';
import {InvalidControlScrollModule} from './shared/utils/InvalidControlScroll/InvalidControlScroll.module';
import {LocationService} from './shared/services/location.service';
import {InputTrimmerModule} from './modules/shared/modules/input-trimmer/input-trimmer.module';
import {
  SurveyMergeModalModule
} from './modules/survey/survey-management/survey-merge-modal-info/survey-merge-modal.module';
import {StaffService} from './shared/services/staff.service';
import {AngularFireModule} from '@angular/fire/compat';
import {AngularFireMessagingModule} from '@angular/fire/compat/messaging';
import {WebSocketService} from './shared/services/web-socket.service';
import {MatCardModule} from '@angular/material/card';
import {SurveyDateSetterComponent} from './modules/shared/modules/survey-date-setter/survey-date-setter.component';
import {EnumKeyService} from './shared/services/enum-key.service';
import {LicenseInfoFormModule} from './modules/shared/modules/license-info-form/license-info-form.module';
import {AmountModalModule} from './modules/shared/modules/amount-modal/amount-modal.module';
import {TooltipModule} from './modules/shared/modules/tooltip/tooltip.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {LocalPaginatorModule} from './modules/shared/modules/local-paginator/local-paginator.module';
import {MatButtonModule} from '@angular/material/button';
import {LocalTableModule} from './shared/components/local-table/local-table.module';
import {CharCounterTextareaModule} from './shared/components/char-counter-textarea/char-counter-textarea.module';
import {
  SpecialistDateSetterComponent
} from './modules/shared/modules/specialist-date-setter/specialist-date-setter.component';
import {
  EditableTextareaWithLinksModule
} from './shared/components/editable-textarea-with-links/editable-textarea-with-links.module';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    AppComponent,
    LogoutComponent,
    RedirectComponent,
    NoPermissionComponent,
    PaymentCheckoutComponent,
    PublicInvoiceViewComponent,
    PermissionPathComponent,
    QuickbooksAuthenticationComponent,
    SurveyDateSetterComponent,
    SpecialistDateSetterComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    PermissionModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    MatSnackBarModule,
    MatStepperModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatTableModule,
    MatDatepickerModule,
    PaymentModalModule,
    ConfirmModalModule,
    AmountModalModule,
    SurveyMergeModalModule,
    PaymentSuccessModalModule,
    NgxStripeModule.forRoot(environment.stripeKey),
    LayoutModule,
    MatMomentDateModule,
    SpinnerButtonModule,
    RounderModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    PortalSelectModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ButtonModule,
    InvalidControlScrollModule,
    InputTrimmerModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    MatCardModule,
    DirectiveModule,
    LicenseInfoFormModule,
    TooltipModule,
    MatMenuModule,
    MatTooltipModule,
    LocalPaginatorModule,
    LocalTableModule,
    MatButtonModule,
    CharCounterTextareaModule,
    EditableTextareaWithLinksModule,
    MatExpansionModule
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    DatePipe,
    TokenService,
    UserService,
    RestService,
    TaxService,
    StripeService,
    PermissionService,
    ResponseSnackbarService,
    SequenceService,
    OwnerService,
    LocationService,
    EnumKeyService,
    StaffService,
    WebSocketService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCallsInterceptor,
      multi: true
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: GeneralConstant.SNACKBAR_DURATION,
        horizontalPosition: GeneralConstant.SNACKBAR_H_POSITION,
        verticalPosition: GeneralConstant.SNACKBAR_V_POSITION
      }
    },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true}
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: {hideSingleSelectionIndicator: true}
    },
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: {hideSingleSelectionIndicator: true}
    },
  ]
})
export class AppModule {
}
